module.exports = __webpack_public_path__ + "img/balance_bg.2673825d.png";